/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const analyticsModule = require('@utils/analytics/analyticsModule');
const commonModule = require('@utils/common/commonModule');
const getFetchModule = require('@utils/get_fetch/getFetchModule');

const AdService = require('./adService');
const AppNexusService = require('./appNexusService');
const appNexusDirective = require('./appNexusDirective');
const NativeAdsService = require('./nativeAdsService');
const nativeAdSlotDirective = require('./nativeAdSlotDirective');
const GoogleAdService = require('./googleAdService');
const googleAdDirective = require('./googleAdDirective');
const adSlotDirective = require('./adSlotDirective');

/**
 * Defines the module for the CMS utility dependencies.
 */
const adsModule = angular
    .module('enervee_utils.ads', [
        analyticsModule.name,
        commonModule.name,
        getFetchModule.name,
    ])
    .factory('AdService', AdService)
    .factory('AppNexusService', AppNexusService)
    .factory('NativeAdsService', NativeAdsService)
    .factory('GoogleAdService', GoogleAdService)
    .directive('appNexusTag', appNexusDirective)
    .directive('nativeAdSlot', nativeAdSlotDirective)
    .directive('googleAd', googleAdDirective)
    .directive('adSlot', adSlotDirective);

module.exports = adsModule;